/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "878948d8068e620b36caf16282ea3fa80e1404e3";
